<template>
  <div>
    <el-table
      v-loading="loading"
      :data="report"
      :key="keys"
      :element-loading-text="infotext"
      style="width: 100%;">
      <el-table-column
        prop="year"
        label="Year"
        width="70em"/>
      <el-table-column
        prop="year"
        label="Month">
        <template slot-scope="scope">
          {{ monthList[(scope.row.month - 1)] }}
        </template>
      </el-table-column>
      <el-table-column label="Scope" width="170pt">
        <template slot-scope="scope">
          <el-select v-model="period" placeholder="Select" @change="getlockdata(scope.row)">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column label="Payroll">
        <template slot-scope="scope">
          <el-button type="success" round size="small" @click="download('payroll',period, scope.row )" ><i class="el-icon-download"/></el-button>
        </template>
      </el-table-column>
      <el-table-column label="Payslip">
        <template slot-scope="scope">
          <el-row :gutter="10">
            <el-col :md="8">
              <el-tooltip placement="left">
                <div slot="content">Send Payslip to all Employee</div>
                <router-link :to="{name:'personnelList',params:{month:scope.row.month,year:scope.row.year,scope:period,cnumber:scope.row.control_number,flag:'regular'}}">
                  <el-button :disabled="(scope.row.index===0)?true:false" round size="small"><span class="fa fa-envelope" /></el-button>
                </router-link>
                <!--el-button :disabled="(scope.row.index===0)?true:false" round size="small" @click="emailPayslip('payslip',period, scope.row )"><span class="fa fa-envelope" /></el-button-->
              </el-tooltip>
            </el-col>
            <el-col :md="14">
              <el-tooltip placement="right">
                <div slot="content">Generate Payslip</div>
                <el-button :disabled="scope.row.index === 0 || isGenerating" type="default" round size="small" @click="generatePayslip('payslip',period, scope.row )" ><i class="fas fa-receipt"/></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <!--el-table-column label="Obligation">
        <template slot-scope="scope">
          <el-button :disabled="(scope.row.index===0)?true:false" type="default" round size="small" @click="download('obligation',period, scope.row )" ><i class="fas fa-receipt"/></el-button>
        </template>
      </el-table-column-->
      <el-table-column label="Indexes">
        <template slot-scope="scope">
          <el-button :disabled="(scope.row.index===0)?true:false" type="default" round size="small" @click="indexes('payroll',period, scope.row )" ><i class="far fa-file-excel" size="7x"/></el-button>
        </template>
      </el-table-column>
      <el-table-column label="FundSource" align="center">
        <template slot-scope="scope">
          <el-button :disabled="(scope.row.index===0)?true:false" type="success" round size="small" @click="generateTotalFundSource('fundSource',period, scope.row )" ><i class="far fa-file" size="7x"/></el-button>
        </template>
      </el-table-column>
      <el-table-column :key="keys" label="Lock data" width="100" align="center">
        <template slot-scope="scope">
          <el-tooltip placement="left">
            <div slot="content">Lock Generated Payroll data</div>
            <el-button v-if="isLockData && scope.row.id === row_ID" type="danger" round size="small" @click="lockdata(scope.row, period, 'unlock')"><span class="fa fa-unlock" /></el-button>
            <el-button v-else type="success" round size="small" @click="lockdata(scope.row, period, 'lock')"><span class="fa fa-lock"/></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--      <el-table-column label="dbf">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button :disabled="(scope.row.index===0)?true:false" type="default" round size="small" @click="dbf('payroll','first', scope.row )" ><i class="far fa-file-excel" size="7x"/></el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </el-table>
    <div style="text-align: center;">
      <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="title"
      width="60%">
      <div>
        <el-table
          :data="fundSourceTable"
          :summary-method="getSummaries"
          show-summary
          style="width: 100%">
          <el-table-column
            prop="fundType"
            label="Fund source"/>
          <el-table-column
            prop="cntPersonnel"
            label="# of Personnel"/>
          <el-table-column
            prop="amount"
            label="Total salary">
            <template slot-scope="scope">
              {{ Number(scope.row.amount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="acaPera"
            label="Total acaPera">
            <template slot-scope="scope">
              {{ Number(scope.row.acaPera).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="amount"
            label="Total amount">
            <template slot-scope="scope">
              {{ Number(scope.row.amount + scope.row.acaPera).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { SummaryLedger } from '@/api/payroll/summaryledger'
import { getToken } from '@/utils/auth'
import { NotifySuccess } from '../../../helper/Helper'
import { Report } from '../../../api/payroll/report'

export default {
  name: 'PayrollReport',
  props: {
    monthList: {
      default: null,
      require: true,
      type: Array
    },
    status: {
      default: 3,
      require: true,
      type: Number
    }
  },
  data() {
    return {
      tableData: [],
      openDialog: false,
      amountTotal: null,
      title: '',
      date_text: null,
      fundSourceTable: [],
      dialogVisible: false,
      meta: {
        page: 1
      },
      astatus: this.status === 3 ? 'Permanent' : 'casCon',
      tenure: this.status,
      // appointStatus: [
      //   { label: 'Permanent', id: 3 },
      //   { label: 'Contractual', id: 2 },
      //   { label: 'Casual', id: 1 }
      // ],
      options: [{
        value: '',
        label: 'Select scope'
      }, {
        value: 'first',
        label: '1st Quencina'
      }, {
        value: 'second',
        label: '2nd Quencina'
      }, {
        value: 'whole',
        label: 'Whole Month'
      }, {
        value: 'scholar',
        label: 'Scholar'
      }],
      period: '',
      infotext: 'Please wait...',
      downlodablefile: null,
      keys: 0,
      url: '',
      base_url: this.$store.getters.base_url,
      report: [],
      loading: false,
      progress: false,
      campus_id: this.$store.getters.user.currentUser.personnel.department.campus_id,
      lockDataRes: null,
      isLockData: false,
      row_ID: null,
      isGenerating: false,
      payslipLoading: null,
      payrollLoading: null
    }
  },
  created() {
    this.loading = true
    // global Echo Echo:true
    // Echo.channel('generate-payroll-index').listen('GeneratePayrollIndex', (e) => {
    //   if (e.data === 'Success') {
    //     this.percent = 100
    //     NotifySuccess('Successfully Generated!')
    //     this.loading = false
    //     this.progress = false
    //     this.getAll()
    //   }
    // })
    this.getAll()
  },
  beforeDestroy() {
    if (this.$echo) {
      this.$echo.leave('payslip-reports')
      this.$echo.leave('general-payroll-reports')
    }
  },
  mounted() {
    if (this.$echo) {
      this.$echo.channel('payslip-reports')
        .listen('GeneratePayslipCompleted', (event) => {
          if (Number(event.userId) === Number(this.$store.getters.user.currentUser.id) || Number(event.user_id) === Number(this.$store.getters.user.currentUser.id)) {
            this.isGenerating = false
            if (this.payslipLoading) {
              this.payslipLoading.close()
            }
            this.$notify({
              title: 'Success',
              message: (event.payload && event.payload.message) || 'Payslip generated successfully.',
              type: 'success'
            })
            if (event.payload && event.payload.download_url) {
              const baseUrl = process.env.VUE_APP_BASE_API.replace(/\/$/, '')
              let rawUrl = event.payload.download_url
              if (rawUrl.startsWith('http')) {
                try {
                  const parsed = new URL(rawUrl)
                  rawUrl = parsed.pathname + parsed.search
                } catch (e) { /* keep as-is */ }
              } else if (!rawUrl.startsWith('/')) {
                const slashIdx = rawUrl.indexOf('/')
                rawUrl = slashIdx !== -1 ? rawUrl.substring(slashIdx) : '/' + rawUrl
              }
              window.open(baseUrl + rawUrl, '_blank')
            }
          }
        })
      this.$echo.channel('general-payroll-reports')
        .listen('GeneratePayrollReportCompleted', (event) => {
          if (Number(event.userId) === Number(this.$store.getters.user.currentUser.id) || Number(event.user_id) === Number(this.$store.getters.user.currentUser.id)) {
            if (this.payrollLoading) {
              this.payrollLoading.close()
            }
            this.$notify({
              title: 'Success',
              message: (event.payload && event.payload.message) || 'Report generated successfully.',
              type: 'success'
            })
            if (event.payload && event.payload.download_url) {
              const baseUrl = process.env.VUE_APP_BASE_API.replace(/\/$/, '')
              let rawUrl = event.payload.download_url
              if (rawUrl.startsWith('http')) {
                try {
                  const parsed = new URL(rawUrl)
                  rawUrl = parsed.pathname + parsed.search
                } catch (e) { /* keep as-is */ }
              } else if (!rawUrl.startsWith('/')) {
                const slashIdx = rawUrl.indexOf('/')
                rawUrl = slashIdx !== -1 ? rawUrl.substring(slashIdx) : '/' + rawUrl
              }
              this.$alert('Your payroll report has been successfully generated and is ready to download.', 'Report Ready', {
                confirmButtonText: 'Download',
                callback: () => {
                  window.open(baseUrl + rawUrl, '_blank')
                }
              })
            }
          }
        })
    }
  },
  methods: {
    lockdata(data, period, label) {
      if (!this.period) {
        this.$message({
          type: 'warning',
          message: 'Select scope to proceed'
        })
        return false
      }
      this.loading = true
      label = (label === 'lock') ? 'lock' : 'unlock'
      const message = 'Are You Sure! You Want to ' + label + ' this ' + this.monthList[(data.month - 1)] + ' ' + data.year + ' Payroll? (' + period + ' Quencina)'
      this.$confirm(message, 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        Report({ control_number: data.control_number, type: 'regular', scope: period, lockID: this.lockDataRes ? this.lockDataRes.id : null, status: (label === 'lock') ? 1 : 0 }, 'post', 'lockData').then(res => {
          this.$message({
            type: 'success',
            message: 'Data has been lock successfully'
          })
          this.getAll()
          this.loading = false
        }).catch(error => {
          console.log(error)
          this.loading = false
        })
      }).catch(() => {
        this.loading = false
        this.$message({
          type: 'info',
          message: 'Cancelled'
        })
      })
    },
    getlockdata(data) {
      this.loading = true
      Report({ control_number: data.control_number, type: 'regular', scope: this.period }, 'post', 'getlockData').then(res => {
        this.lockDataRes = res.data.result
        this.isLockData = !!(this.lockDataRes && this.lockDataRes.status === 1)
        this.row_ID = data.id
        this.keys++
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    getSummaries(param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total'
        }
        if (index === 2) {
          const number = this.amountTotal.overTotalSalary
          sums[index] = number.toLocaleString('en-US')
        }
        if (index === 3) {
          const number = this.amountTotal.overTotalAcaPera
          sums[index] = number.toLocaleString('en-US')
        }
        if (index === 4) {
          const number = this.amountTotal.overAllTotal
          sums[index] = number.toLocaleString('en-US')
        }
      })
      return sums
    },
    getAll() {
      this.keys++
      this.isLockData = false
      this.period = ''
      this.progress = false
      SummaryLedger({ report: true, page: this.meta.page, tenure: this.tenure, campus_id: this.campus_id }, 'get', '').then(res => {
        this.report = res.data.summary_ledger
        this.meta = res.data.meta
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    show() {
      console.log(this.astatus)
      // this.astatus = this.astatus
      // alert('this function not yet available')
    },
    generatePayslip(type, option, row) {
      if (!this.period) {
        this.$message({
          type: 'warning',
          message: 'Select scope to proceed'
        })
        return false
      }
      this.isGenerating = true
      this.payslipLoading = this.$loading({
        lock: true,
        text: 'Generating payslip. This might take a while...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Report({ year: row.year, status: true, astatus: this.astatus, month: row.month, option: option, type: type, dsk: row.id, control_number: row.control_number, tenure: this.tenure, campus_id: row.campus_id }, 'get', 'generatePayslip').then(res => {
        if (res.data && res.data.file) {
          this.downlodablefile = res.data.file
          this.percent = 100
          NotifySuccess('Successfully Generated!')
          this.getAll()
          this.downloadfile('data:application/pdf;base64, ' + this.downlodablefile)
          this.isGenerating = false
          if (this.payslipLoading) {
            this.payslipLoading.close()
          }
        } else {
          this.$notify({
            title: 'Processing',
            message: 'Payslip generation started. Please wait, it will download automatically.',
            type: 'info'
          })
        }
      }).catch(error => {
        console.log(error)
        this.isGenerating = false
        if (this.payslipLoading) {
          this.payslipLoading.close()
        }
      })
    },
    download(type, option, row) {
      if (!this.period) {
        this.$message({
          type: 'warning',
          message: 'Select scope to proceed'
        })
        return false
      }
      this.downlodablefile = null
      this.payrollLoading = this.$loading({
        lock: true,
        text: 'Generating payroll report. This might take a while...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Report({ year: row.year, status: true, astatus: this.astatus, month: row.month, option: option, type: type, dsk: row.id, tenure: this.tenure, campus_id: row.campus_id, control_number: row.control_number }, 'get', 'download').then(res => {
        if (res.data && res.data.file) {
          this.downlodablefile = res.data.file
          this.percent = 100
          NotifySuccess('Successfully Generated!')
          this.getAll()
          this.downloadfile('data:application/pdf;base64, ' + this.downlodablefile)
          if (this.payrollLoading) {
            this.payrollLoading.close()
          }
        } else {
          this.$notify({
            title: 'Processing',
            message: 'Payroll report generation started. Please wait, it will download automatically.',
            type: 'info'
          })
        }
      }).catch(error => {
        console.log(error)
        if (this.payrollLoading) {
          this.payrollLoading.close()
        }
      })
    },
    generateTotalFundSource(type, option, row) {
      if (!this.period) {
        this.$message({
          type: 'warning',
          message: 'Select scope to proceed'
        })
        return false
      }
      this.loading = true
      Report({ year: row.year, status: true, astatus: this.astatus, month: row.month, option: option, type: type, dsk: row.id, tenure: this.tenure, campus_id: row.campus_id }, 'get', 'TotalAmountPerFundSource').then(res => {
        // console.log(res.data)
        this.date_text = res.data.date
        this.fundSourceTable = res.data.list
        this.amountTotal = res.data.total
        this.dialogVisible = true
        this.title = 'General Payroll for the period ( ' + this.date_text + ' )'
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    indexes(type, option, row) {
      if (!this.period) {
        this.$message({
          type: 'warning',
          message: 'Select scope to proceed'
        })
        return false
      }
      this.url = this.base_url + '/payroll/report/excel?year=' + row.year + '&astatus=' + this.astatus + '&status=' + true + '&month=' + row.month + '&option=' + option + '&type=' + type + '&token=' + getToken() + '&dsk=' + row.id + '&tenure=' + this.tenure + '&campus_id=' + row.campus_id
      window.open(this.url, '_blank')
    },
    // dbf(type, option, row) {
    //   this.url = this.base_url + '/api/payroll/sample/dbf?year=' + row.year + '&astatus=' + this.astatus + '&month=' + row.month + '&option=' + option + '&type=' + type + '&token=' + getToken() + '&dsk=' + row.id
    //   window.open(this.url, '_blank')
    // },
    downloadfile(base64URL) {
      var b64 = base64URL
      // if Internet Explorer or Edge
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        var byteCharacters = atob(this.downlodablefile)
        var byteNumbers = new Array(byteCharacters.length)
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        var blob = new Blob([byteArray], { type: 'application/pdf' })
        window.navigator.msSaveOrOpenBlob(blob, 'file-xxx.pdf')
      } else {
        var ww = window.open('about:blank')
        var iframeElem0 = ww.document.createElement('iframe')
        iframeElem0.style = 'position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;'
        setTimeout(function() { // FireFox seems to require a setTimeout for this to work.
          iframeElem0.src = b64
          ww.document.body.appendChild(iframeElem0)
        }, 0)
      }
    }
  }
}
</script>

<style scoped>

</style>
